/**
 * Different Button designs.
 * @public
 */
enum ButtonDesign {
	/**
	 * default type (no special styling)
	 * @public
	 */
	Default = "Default",

	/**
	 * accept type (green button)
	 * @public
	 */
	Positive = "Positive",

	/**
	 * reject style (red button)
	 * @public
	 */
	Negative = "Negative",

	/**
	 * transparent type
	 * @public
	 */
	Transparent = "Transparent",

	/**
	 * emphasized type
	 * @public
	 */
	Emphasized = "Emphasized",

	/**
	 * attention type
	 * @public
	 */
	Attention = "Attention",
}

export default ButtonDesign;
